import { Choice, Choices } from "@/models/Message";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import React from "react";

type Props = {
  choices: Choices;
  onChoiceClick?: (choice: Choice) => void;
};

export const ChoiceButtons: React.FC<Props> = ({ choices, onChoiceClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      {choices.map((choice) => {
        let buttonClassName = classes.button;
        let disabled = false;

        if (choice.selected === true) {
          buttonClassName = classes.selectedButton;
          disabled = true;
        } else if (choice.selected !== undefined && choice.selected === false) {
          buttonClassName = classes.notSelectedButton;
          disabled = true;
        }

        return (
          <Button
            key={choice.value}
            className={buttonClassName}
            // appearance={buttonAppearance}
            onClick={() => onChoiceClick?.(choice)}
            disabled={disabled}
          >
            {choice.label}
          </Button>
        );
      })}
    </div>
  );
};

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    gap: tokens.spacingHorizontalXS,
    alignItems: "space-between",
  },
  button: {
    border: `1px solid ${tokens.colorBrandForegroundLink}`,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorBrandForegroundLink,
    backgroundColor: tokens.colorNeutralBackground1,

    ":hover": {
      border: `1px solid ${tokens.colorBrandForegroundLinkHover}`,
      color: tokens.colorBrandForegroundLinkHover,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },

    ":active": {
      border: `1px solid ${tokens.colorBrandForegroundLinkPressed}`,
      color: tokens.colorBrandForegroundLinkPressed,
      backgroundColor: tokens.colorNeutralBackground1Pressed,
    },
  },
  selectedButton: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForegroundLinkSelected,
    border: `1px solid ${tokens.colorNeutralStrokeDisabled}`,
    backgroundColor: tokens.colorNeutralBackground1Selected,
  },
  notSelectedButton: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForegroundDisabled,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
});
